<template>
  <div class="container">
    <Breadcrumbs :items="breadcrumbs" />
    <div class="text-lg py-20 lg:py-32">
      <h1 class="section-headline text-center mb-20 lg:mb-32">
        Privacy Policy del sito web UniCredit RE Services S.p.A.
      </h1>
      <div class="mb-12">
        <p class="paragraph mb-6">Perché questo avviso?</p>
        <p class="mb-6">
          In questa pagina si descrivono le modalità di gestione del sito Web di
          UniCredit RE Services S.p.A., in riferimento al trattamento dei dati
          personali degli utenti che li consultano. Si tratta di un'informativa
          che è resa anche ai sensi degli artt. 13 e 14 del Regolamento UE n.
          679/2016 a coloro che interagiscono con i servizi web di UniCredit RE
          Services S.p.A., accessibili per via telematica a partire
          dall'indirizzo
          <a
            class="text-blue underline hover:no-underline"
            target="_blank"
            href="https://www.unicreditres.it"
            >https://www.unicreditres.it</a
          >
          corrispondenti alla pagina iniziale del sito di UniCredit RE Services
          S.p.A.. L'informativa è resa solo per il sito web di UniCredit RE
          Services S.p.A. e non anche per altri siti web eventualmente
          consultati dall'utente tramite link.
        </p>
        <p class="mb-6">
          L'informativa si ispira anche alla Raccomandazione n. 2/2001 che le
          Autorità Europee per la protezione dei dati personali, riunite nel
          Gruppo istituito dall'art. 29 della direttiva n. 95/46/CE, hanno
          adottato il 17 maggio 2001 per individuare alcuni requisiti minimi per
          la raccolta di dati personali on-line e, in particolare, le modalità,
          i tempi e la natura delle informazioni che i titolari del trattamento
          devono fornire agli utenti quando questi si collegano a pagine web,
          indipendentemente dagli scopi del collegamento.
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">Il "Titolare" del trattamento</p>
        <p class="mb-6">
          A seguito della consultazione di questo sito possono essere trattati
          dati relativi a persone identificate o identificabili. Il "Titolare"
          del loro trattamento è UniCredit RE Services S.p.A., che ha Sede
          Sociale e Direzione Generale in {{ $config.brandAddress.full }}. Nelle
          varie sezioni del sito web, qualora vengano effettuati trattamenti di
          dati, sono indicati i relativi Responsabili del trattamento.
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">Luogo di trattamento dei dati</p>
        <p class="mb-6">
          I trattamenti connessi ai servizi web di questo sito hanno luogo
          presso la predetta Direzione Generale ed anche presso la sede di
          Bologna della Società e sono curati solo dal personale di UniCredit RE
          Services S.p.A., incaricato del trattamento, oppure dal personale di
          autorizzato Immobiliare.it. S.p A., “Responsabile” del trattamento
          designato dal Titolare.
        </p>
        <p class="mb-6">
          Nessun dato personale derivante dal servizio web viene diffuso.
        </p>
        <p class="mb-6">
          I dati personali forniti dagli utenti sono utilizzati al solo fine di
          eseguire il servizio o la prestazione richiesta e sono comunicati a
          terzi nel solo caso in cui ciò sia a tal fine necessario.
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">Tipi di dati trattati</p>
        <p class="mb-6"><em>Dati di navigazione</em></p>
        <p class="mb-6">
          I sistemi informatici e le procedure software utilizzate per il
          funzionamento di questo sito web acquisiscono, nel corso del loro
          normale esercizio, alcuni dati personali la cui trasmissione è
          implicita nell'uso della rete Internet, che risulta basata sul
          protocollo TCP/IP. Si tratta di informazioni che non sono raccolte per
          essere associate a interessati identificati, ma che per loro stessa
          natura potrebbero, attraverso elaborazioni ed associazioni con dati
          detenuti da terzi, permettere di identificare gli utenti navigatori.
          In questa categoria di dati rientrano gli "indirizzi IP" o i nomi a
          dominio dei computer utilizzati dagli utenti che si connettono al
          sito, gli indirizzi in notazione URI (Uniform Resource Identifier)
          delle risorse richieste, l'orario della richiesta, il metodo
          utilizzato nel sottoporre la richiesta al server web, la dimensione
          del file ottenuto in risposta, il codice numerico indicante lo stato
          della risposta data dal server web (buon fine, errore, ecc...) ed
          altri parametri relativi al sistema operativo ed all'ambiente
          informatico dell'utente. Questi dati vengono utilizzati al solo fine
          di ricavare informazioni statistiche anonime sull'uso del sito e per
          controllarne il corretto funzionamento del sito web di UniCredit RE
          Services S.p.A.. Si evidenzia che i predetti dati potrebbero essere
          utilizzati per l'accertamento di responsabilità in caso di reati
          informatici ai danni del sito web di UniCredit RE Services S.p.A. o ad
          altri siti ad esso connessi o collegati: salva questa eventualità, i
          dati di navigazione sono cancellati subito dopo la relativa
          elaborazione statistica e in ogni caso vengono conservati per 24 mesi
          dal momento della raccolta.
        </p>
        <p class="mb-6"><em>Dati forniti volontariamente dall'utente</em></p>
        <p class="mb-6">
          La richiesta di invio di posta elettronica agli indirizzi indicati
          nell'apposita sezione del sito web di UniCredit RE Services S.p.A.,
          comporta la successiva acquisizione di alcuni dati personali del
          richiedente, compreso l'indirizzo e-mail del richiedente, necessario
          per rispondere alle richieste. Specifiche informative di sintesi
          verranno progressivamente riportate o visualizzate nelle pagine del
          sito predisposte per questi particolari servizi a richiesta.
        </p>
        <p class="mb-6"><em>Cookies</em></p>
        <p class="mb-6">
          Un cookie è un piccolo "file di testo" che alcuni siti web, mentre
          vengono visitati, possono inviare all'indirizzo dell'utente che li sta
          navigando al fine di tracciare le preferenze manifestate e raccogliere
          dati in forma esclusivamente anonima per migliorare l'offerta e la
          fruibilità del sito stesso. Per tali motivi anche il server Web di
          UniCredit RE Services, durante la navigazione del proprio sito, può
          scambiare dei cookies con gli elaboratori degli utenti. Ogni utente,
          se preferisce, può comunque impostare il proprio browser in maniera
          tale da ricevere un avvertimento della presenza di un cookie e
          decidere se accettarlo o rifiutarlo. È possibile anche rifiutare
          automaticamente la ricezione dei cookies attivando l'apposita opzione
          del browser: il mancato utilizzo dei cookies, tuttavia, potrebbe
          comportare difficoltà nell'interazione con il sito della società.
        </p>
        <p class="mb-6"><em>Call Center</em></p>
        <p class="mb-6">
          I sistemi e le procedure preposti al funzionamento del Call Center di
          UniCredit RE Services, acquisiscono alcuni dati riferiti alle chiamate
          dei clienti. In questa categoria rientrano il numero remoto del
          chiamante (laddove non occultato), i dati di navigazione
          nell'alberatura dell'IVR (cioè le azioni/digitazioni che il cliente
          compie per accedere ai vari servizi), durata della chiamata, nonché
          solo nei casi espressamente previsti e previo avviso all'interessato,
          registrazione audio della chiamata. I dati sopra citati vengono
          trattati al fine di ricavare informazioni statistiche anonime
          sull'utilizzo del Call Center, per controllarne il corretto
          funzionamento e garantirne la sicurezza, nonché per l'accertamento di
          responsabilità in caso di eventuali illeciti, ai danni di UniCredit RE
          Services, o dei clienti della stessa.
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">
          Facoltatività del conferimento dei dati personali
        </p>
        <p class="mb-6">
          A parte quanto specificato per i dati di navigazione, l'utente è
          libero di fornire i dati personali riportati negli appositi moduli
          elettronici di richiesta, nelle sezioni del sito web predisposte per
          particolari servizi a richiesta. Si evidenzia peraltro che il loro
          mancato conferimento può comportare l'impossibilità di ottenere quanto
          richiesto.
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">
          Modalità del trattamento e misure di sicurezza
        </p>
        <p class="mb-6">
          I dati personali sono trattati con strumenti automatizzati e non, per
          il solo tempo strettamente necessario a conseguire gli scopi per cui
          sono stati raccolti. Specifiche misure di sicurezza sono osservate per
          prevenire la perdita dei dati, usi illeciti o non corretti ed accessi
          non autorizzati. In particolare, nelle sezioni del sito web
          predisposte per particolari servizi, dove vengono richiesti dati
          personali all'utente navigatore, il canale attraverso cui transitano i
          dati è cifrato tramite tecnologie di sicurezza chiamate Secure Sockets
          Layer & Transport Layer Security, abbreviate in SSL/TLS. La tecnologia
          SSL/TLS rende disponibile un canale cifrato nella quale viaggiano le
          informazioni prima che queste vengano scambiate via Internet tra
          l'elaboratore dell'utente ed i sistemi centrali di UniCredit S.p.A.,
          rendendole incomprensibili ai non autorizzati e garantendo in questo
          modo la riservatezza delle informazioni trasmesse. L'utilizzo
          dell'SSL/TLS richiede peraltro un browser compatibile in grado di
          eseguire lo "scambio" di una chiave di sicurezza avente una lunghezza
          minima di 128 bit., necessaria per stabilire la predetta connessione
          sicura con i sistemi centrali di UniCredit RE Services S.p.A..
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">Diritti degli interessati</p>
        <p class="mb-6">
          I soggetti cui si riferiscono i dati personali, eventualmente raccolti
          nelle predette sezioni specifiche, hanno il diritto, ai sensi degli
          artt. 15 e seguenti del Regolamento UE n. 679/2016, di conoscere in
          qualunque momento quali sono i dati personali in possesso di UniCredit
          RE Services S.p.A. e come questi vengono utilizzati (Diritto di
          accesso), di ottenerne l'aggiornamento, la rettifica o, se vi è
          interesse, l'integrazione, nonché la cancellazione, la trasformazione
          in forma anonima o la limitazione e possono in qualsiasi momento
          revocare, laddove rilasciato, il consenso al trattamento dei dati: per
          finalità di invio di materiale commerciale e pubblicitario, alla
          vendita diretta o a ricerche di mercato (i.e. marketing diretto)
        </p>
        <p class="mb-6">Le eventuali richieste vanno rivolte a:</p>
        <p class="mb-6">
          <strong>UniCredit RE Services S.p.A.</strong><br aria-hidden="true" />
          <strong>Legale & Compliance</strong><br aria-hidden="true" />
          {{ $config.brandAddress.street }}<br aria-hidden="true" />
          {{ $config.brandAddress.city }}<br aria-hidden="true" />
          Fax: +39 02 97688500 Indirizzo e-mail:
          <a
            class="text-blue underline hover:no-underline"
            target="_blank"
            href="mailto:privacy@unicreditreservices.it"
            >privacy@unicreditreservices.it</a
          >
        </p>
      </div>
      <div class="mb-12">
        <p class="paragraph mb-6">Minori</p>
        <p class="mb-6">
          UniCredit RE Services S.p.A. non utilizza consapevolmente il proprio
          sito web per richiedere dati a minori di 18 anni.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import Breadcrumbs from '~/components/Breadcrumbs.vue'

export default {
  components: { Breadcrumbs },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'La mia Homepage',
          href: '/',
        },
        {
          text: 'Privacy',
          href: '/privacy',
        },
        {
          text: 'Informativa relativa al sito web',
        },
      ],
    }
  },
  head() {
    return {
      title: 'Informativa relativa sito web - UniCredit RE Services',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Area riservata | Informativa relativa sito web - UniCredit RE Services',
        },
      ],
    }
  },
}
</script>
